import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=71e220d4&scoped=true"
import script from "./reportList.vue?vue&type=script&lang=js"
export * from "./reportList.vue?vue&type=script&lang=js"
import style0 from "./reportList.vue?vue&type=style&index=0&id=71e220d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e220d4",
  null
  
)

export default component.exports